
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Cabserviceinpimprichichwad() {



    const cardData =
    {
        keyword: 'Cab Service in Pimpri Chinchwad',
        heading: 'Meghana Cab : Cab Service in Pimpri Chinchwad',
        headingDescription: 'Meghana Cab offers trusted Cab Service in Pimpri Chinchwad, providing fast, affordable, and comfortable transportation for your local and outstation needs. Whether it is a daily commute, airport transfer, business meeting, or weekend trip, our clean cabs and experienced drivers ensure a hassle-free ride. With 24/7 availability, easy booking, and transparent pricing, we serve every corner of Pimpri Chinchwad with punctual and professional service. Book your cab with Meghana Cab and experience the best cab service in Pimpri Chinchwad today!',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th-century monolithic rock-cut temple dedicated to Lord Shiva, located in the city center. It features beautifully carved pillars, a sanctum with a Shiva Lingam, and a tranquil atmosphere, offering a peaceful retreat from the urban hustle."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, this internationally known meditation center offers a serene environment for spiritual growth and relaxation. The resort includes lush gardens, wellness sessions, and dynamic meditation programs, attracting visitors from all over the world."
  },
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, this iconic fortification was once the seat of power. Although much of it was destroyed in a fire, the remaining gates and foundations provide insight into its architectural grandeur. The evening light and sound show adds to its historical allure."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japanese landscape design, this garden offers calm surroundings, flowing water channels, koi ponds, and manicured pathways. It's an ideal location for walking, photography, or simply spending quiet time with family."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Built in 1892, this historic site played a key role during India’s independence movement. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi. The palace is surrounded by landscaped gardens and houses a museum dedicated to Gandhi's life."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Located around 20 kilometers from Pune, this dam is a popular destination for short drives, scenic views, and relaxing by the lakeside. The area is especially pleasant during the monsoon season and is often frequented by picnickers and food vendors."
  },
  {
    "title": "Fergusson College Road",
    "description": "A lively street known for its youthful vibe, lined with cafes, bookstores, fashion boutiques, and street food stalls. It's a favorite spot for students and a great place to experience Pune’s modern culture and social scene."
  },
  {
    "title": "Lal Mahal",
    "description": "This historic red-brick palace was built by Shahaji Bhosale in the 1630s for his son Shivaji Maharaj. Though the original structure no longer exists, the rebuilt palace displays important moments from Shivaji’s childhood through murals and artifacts."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "A unique museum showcasing over 20,000 artifacts including sculptures, musical instruments, weapons, household items, and artwork from different periods of Indian history. It offers deep insights into India’s rich cultural and artistic legacy."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 30 kilometers from the city, Sinhagad Fort is an important historical site known for its role in the Battle of Sinhagad. The moderate trek to the top is rewarded with panoramic views, Maratha-era architecture, and local food stalls serving traditional dishes."
  }
],

"services": [
    {
        "name": "Cab Near Me Pimpri Chinchwad",
        "description": "Find a reliable cab near you in Pimpri Chinchwad with Meghana Cab. Our service ensures fast pickup and smooth travel across PCMC and Pune city."
    },
    {
        "name": "Book Taxi in Pimpri Chinchwad",
        "description": "Easily book a taxi in Pimpri Chinchwad with Meghana Cab’s convenient booking options. Enjoy quick confirmation and comfortable rides within or outside the city."
    },
    {
        "name": "Affordable Cab Service PCMC",
        "description": "Meghana Cab provides affordable taxi services in the PCMC area. Choose from budget-friendly options for local, daily, or outstation travel."
    },
    {
        "name": "Outstation Taxi from Pimpri Chinchwad",
        "description": "Travel out of town with our outstation taxi service from Pimpri Chinchwad. Meghana Cab offers comfortable vehicles and skilled drivers for long-distance travel."
    },
    {
        "name": "Online Cab Booking PCMC",
        "description": "Book your cab online in Pimpri Chinchwad through Meghana Cab’s easy-to-use platform. Real-time availability, instant quotes, and fast booking included."
    },
    {
        "name": "Local Taxi Hire in Pimpri Chinchwad",
        "description": "Hire taxis locally within Pimpri Chinchwad for daily errands, shopping, meetings, or short rides with Meghana Cab’s dependable local travel service."
    },
    {
        "name": "Pimpri to Pune Airport Taxi",
        "description": "Book a hassle-free airport taxi from Pimpri Chinchwad to Pune Airport. We ensure timely pickups and smooth airport transfers 24/7."
    },
    {
        "name": "24/7 Cab Service in Pimpri Area",
        "description": "Need a ride any time of day? Meghana Cab provides 24/7 taxi service in Pimpri Chinchwad with professional drivers and well-maintained vehicles."
    },
    {
        "name": "Budget Cab PCMC",
        "description": "Looking for a cost-effective ride? Meghana Cab offers budget cabs in the PCMC area that fit your travel and pocket comfortably."
    },
    {
        "name": "AC Taxi Hire Pimpri Chinchwad",
        "description": "Enjoy air-conditioned comfort with Meghana Cab’s AC taxi hire in Pimpri Chinchwad. Ideal for all weather conditions and travel needs."
    },
    {
        "name": "Round Trip Cabs from Pimpri Chinchwad",
        "description": "Book round-trip taxis from Pimpri Chinchwad for outstation or city tours. Meghana Cab offers reliable return journey options for any destination."
    },
    {
        "name": "Taxi for Events Pimpri Chinchwad",
        "description": "Planning a function or event? Hire event taxis in Pimpri Chinchwad with Meghana Cab for guest travel, pickups, and smooth logistics."
    },
    {
        "name": "Sedan & SUV Cabs PCMC",
        "description": "Choose between spacious SUVs or elegant sedans for your ride in Pimpri Chinchwad. Meghana Cab offers multiple vehicle types to suit your trip."
    },
    {
        "name": "Corporate Cab Hire PCMC",
        "description": "Get reliable corporate cab services in PCMC with Meghana Cab. Perfect for office commutes, client visits, or team events with invoicing options."
    },
    {
        "name": "Family Taxi Service in Pimpri Chinchwad",
        "description": "Meghana Cab provides safe and comfortable taxi options for families in Pimpri Chinchwad. Ideal for weekend getaways, city travel, or long trips."
    }
],

"tableData": [
    ["Cab Near Me Pimpri Chinchwad", "Book Taxi in Pimpri Chinchwad"],
    ["Affordable Cab Service PCMC", "Outstation Taxi from Pimpri Chinchwad"],
    ["Online Cab Booking PCMC", "Local Taxi Hire in Pimpri Chinchwad"],
    ["Pimpri to Pune Airport Taxi", "24/7 Cab Service in Pimpri Area"],
    ["Budget Cab PCMC", "AC Taxi Hire Pimpri Chinchwad"],
    ["Round Trip Cabs from Pimpri Chinchwad", "Taxi for Events Pimpri Chinchwad"],
    ["Sedan & SUV Cabs PCMC", "Corporate Cab Hire PCMC"],
    ["Family Taxi Service in Pimpri Chinchwad", ""],
    ["", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Reliable Cab Service in Pimpri Chinchwad",
        "WhyChoosedescription": "Meghana Cab offers trusted and convenient cab service in Pimpri Chinchwad for local travel, airport transfers, office commutes, and outstation trips. Enjoy safe and smooth rides at any time of the day."
    },
    {
        "WhyChooseheading": "Fast Pickups Across Pimpri Chinchwad",
        "WhyChoosedescription": "Wherever you are—Pimpri, Chinchwad, Akurdi, Nigdi, or Hinjewadi—our cabs reach you quickly. We ensure minimal waiting time and timely pickups to keep your day running smoothly."
    },
    {
        "WhyChooseheading": "Experienced Local Drivers",
        "WhyChoosedescription": "Our drivers are well-versed with the Pimpri Chinchwad area and surrounding routes. They ensure safe, efficient, and comfortable travel whether you're headed across town or out of the city."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Cabs",
        "WhyChoosedescription": "All Meghana Cab vehicles are regularly serviced and sanitized, providing a hygienic, air-conditioned, and pleasant environment for your travel needs."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Fare Structure",
        "WhyChoosedescription": "We offer competitive pricing with no hidden charges. With Meghana Cab, you get honest fares and value-for-money service in every ride you book in Pimpri Chinchwad."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability in Pimpri Chinchwad",
        "WhyChoosedescription": "Need a cab early in the morning or late at night? Meghana Cab operates round-the-clock, so you always have a reliable taxi option no matter the time."
    },
    {
        "WhyChooseheading": "Wide Range of Cab Options",
        "WhyChoosedescription": "From hatchbacks and sedans to SUVs and tempo travellers, we offer a variety of cab types for solo, group, or business travel requirements in and around Pimpri Chinchwad."
    },
    {
        "WhyChooseheading": "Easy Booking via App, Website or Call",
        "WhyChoosedescription": "Booking a cab in Pimpri Chinchwad is quick and easy. Use our mobile app, website, or simply call our customer support for instant and reliable service."
    }
]





























    }

const faqData = [
    {
        question: "How can I book a cab in Pimpri Chinchwad with Meghana Cab?",
        answer: "You can easily book a cab in Pimpri Chinchwad by calling Meghana Cab at +91 9075462128 or booking online through our website."
    },
    {
        question: "Is Meghana Cab service available 24/7 in Pimpri Chinchwad?",
        answer: "Yes, we operate round-the-clock in Pimpri Chinchwad, providing reliable cab services any time of the day or night."
    },
    {
        question: "What types of cabs are available for booking in Pimpri Chinchwad?",
        answer: "We offer hatchbacks, sedans, SUVs, and tempo travellers to suit your travel needs and group size."
    },
    {
        question: "Can I book a cab for local and outstation travel from Pimpri Chinchwad?",
        answer: "Absolutely! Meghana Cab offers both local and outstation cab services from Pimpri Chinchwad."
    },
    {
        question: "Are Meghana Cab drivers experienced and professional?",
        answer: "Yes, our drivers are well-trained, courteous, and familiar with routes in and around Pimpri Chinchwad."
    },
    {
        question: "Do you provide one-way and round-trip cab options in Pimpri Chinchwad?",
        answer: "Yes, we provide both one-way and round-trip cab services based on your travel requirements."
    },
    {
        question: "Are your vehicles clean and well-maintained?",
        answer: "All Meghana Cab vehicles are regularly serviced and sanitized to ensure safety and comfort."
    },
    {
        question: "Can I request multiple stops during my ride?",
        answer: "Yes, you can inform us during booking if you need multiple stops so we can plan accordingly."
    },
    {
        question: "What payment options are available for cab services in Pimpri Chinchwad?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash for your convenience."
    },
    {
        question: "How do I contact Meghana Cab for bookings in Pimpri Chinchwad?",
        answer: "You can call us at +91 9075462128 for bookings, pricing, or any travel assistance."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Kiran Jagtap',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab offers the best cab service in Pimpri Chinchwad. The driver arrived on time and the ride was smooth. Highly recommended!”',
    },
    {
        name: 'Ms. Neha Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Reliable and safe cab service in Pimpri Chinchwad by Meghana Cab. Booking was easy and the driver was professional.”',
    },
];






















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Pimpri Chinchwad",
  "image": "https://www.meghanacabs.com/assets/images/cab-service-pimpri-chinchwad.jpg",
  "description": "Reliable and affordable cab service in Pimpri Chinchwad by Meghana Cabs. Book local, outstation, and airport taxis with 24/7 availability for all your travel needs.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5105"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "350",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/cab-service-pimpri-chinchwad"
  }
};





    return (
        <div>


<Helmet>
  <title>Cab Service in Pimpri Chinchwad | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Reliable and affordable cab service in Pimpri Chinchwad by Meghana Cabs. Book local, outstation, and airport taxis with 24/7 availability for all your travel needs." 
  />
  <meta 
    name="keywords" 
    content="Cab Near Me Pimpri Chinchwad, Book Taxi in Pimpri Chinchwad, Affordable Cab Service PCMC, Outstation Taxi from Pimpri Chinchwad, Online Cab Booking PCMC, Local Taxi Hire in Pimpri Chinchwad, Pimpri to Pune Airport Taxi, 24/7 Cab Service in Pimpri Area, Budget Cab PCMC, AC Taxi Hire Pimpri Chinchwad, Round Trip Cabs from Pimpri Chinchwad, Taxi for Events Pimpri Chinchwad, Sedan & SUV Cabs PCMC, Corporate Cab Hire PCMC, Family Taxi Service in Pimpri Chinchwad" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/18.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinpimprichichwad;